import React from 'react'

const Statistics = () => {
  return (
    <section>
        <div className="w3-container w3-row w3-center w3-dark-grey w3-padding-64">
    <div className="w3-quarter">
      <span className="w3-xxlarge">14+</span>
      <br />
      Partners
    </div>
    <div className="w3-quarter">
      <span className="w3-xxlarge">55+</span>
      <br />
      Projects Done
    </div>
    <div className="w3-quarter">
      <span className="w3-xxlarge">89+</span>
      <br />
      Happy Clients
    </div>
    <div className="w3-quarter">
      <span className="w3-xxlarge">150+</span>
      <br />
      Meetings
    </div>
  </div>  
    </section>
  )
}

export default Statistics